<button *ngIf="isPending"  title="Resend activation email to pending user" class="sendEmailButton" (click)="sendActivationEmail()" [disabled]="!disabled">
          <div class="svg-container">
            <svg-icon-sprite class="normal" [src]="'assets/sprite/sprite.svg#icon-send-email'" [classes]="'icon-send-email--white'" [width]="'18px'" [height]="'18px'"></svg-icon-sprite>
          </div>
          <div class="btn-text">Re-send Activation Email</div>
</button>
<div *ngIf="!isPending">{{data.lastSuccessfulTwoFALogin | date: 'MM/dd/yyyy'}}</div>
